import * as React from 'react';
import classNames from 'classnames';
import {Flex, Text, Collapsible, NOOP} from 'components/UIKit';
import styles from './item.scss';

export interface ItemState {
  isOpen: boolean;
}

export interface ItemProps {
  title: string;
  isOpen?: boolean;
  onToggle?: () => any;
  children: React.ReactNode;
}

export class Item extends React.Component<ItemProps, ItemState> {
  state: ItemState = {isOpen: false};

  handleToggleClick = () => {
    const {isOpen: propsIsOpen, onToggle = NOOP} = this.props;

    if (propsIsOpen !== undefined) {
      onToggle();
      return;
    }

    this.setState((state) => ({
      isOpen: !state.isOpen,
    }));
  };

  render() {
    const {isOpen: stateIsOpen} = this.state;
    const {title, children, isOpen: propsIsOpen} = this.props;

    const isOpen = propsIsOpen === undefined ? stateIsOpen : propsIsOpen;

    return (
      <div className={classNames(styles.itemWrapper, {[styles.open]: isOpen})}>
        <div className={styles.item}>
          <button
            aria-expanded={isOpen}
            className={styles.activator}
            type="button"
            onClick={this.handleToggleClick}
          >
            <Flex
              justifyContent="space-between"
              alignItems="center"
              wrap="nowrap"
              className={styles.heading}
            >
              <Text component="p" align="left" className={styles.title} resetMargin>
                {title}
              </Text>
              <span className={styles.openIndicator} />
            </Flex>
          </button>
          <Collapsible id={title} isOpen={isOpen}>
            <div className={styles.collapsibleContentWrapper}>{children}</div>
          </Collapsible>
        </div>
      </div>
    );
  }
}
